// @flow
import React, { Fragment, useContext } from 'react';

import { t } from 'Src/i18n';
import ResponsiveContext from 'Components/utils/responsive/responsiveContext';
import { Scrollable } from 'Components/frameworks/scrollable/Scrollable';
import { AlternativeResortThumbnail } from './AlternativeResortThumbnail';
import { AlternativeResortCriteria } from './AlternativeResortCriteria';

type Props = {|
  adultsNumber: number,
  arrivalDate: string,
  departureCity: string,
  duration: number,
  i18n: CMSContent,
  kidsNumber: number,
  suggestions: $ReadOnlyArray<ResortSuggestion>,
  selectResortHandler?: (id: string, name: string) => mixed,
  scrollToBookingEngineEntryPoint?: () => void,
  categoryGA?: string,
|};

export const AlternativeResort = (props: Props) => {
  const {
    adultsNumber,
    arrivalDate,
    departureCity,
    duration,
    i18n,
    kidsNumber,
    suggestions,
    selectResortHandler,
    scrollToBookingEngineEntryPoint,
    categoryGA = 'resort',
  } = props;
  const { isBrowserGreaterThan } = useContext(ResponsiveContext);

  return (
    <div className="flex justify-center w-full mt-10" data-testid="AlternativeResort">
      <div className="AlternativeResort-wrapper px-6 w-full">
        <div className="AlternativeResort-title font-bold text-blue text-xl">
          {t('booking.counterProposalPopIn.resortCounterProposalTitle')}
        </div>
        <div className="AlternativeResort-content md:flex md:mt-4 md:flex-wrap">
          <AlternativeResortCriteria
            adultsNumber={adultsNumber}
            arrivalDate={arrivalDate}
            departureCity={departureCity}
            duration={duration}
            i18n={i18n}
            kidsNumber={kidsNumber}
          />
          {isBrowserGreaterThan.S ? (
            <Fragment>
              {suggestions.map((suggestion, index) => {
                return (
                  <AlternativeResortThumbnail
                    key={suggestion.resort.id}
                    suggestion={suggestion}
                    className={index < suggestions.length - 1 ? 'mr-4 rtl:mr-4' : ''}
                    onClick={selectResortHandler}
                    categoryGA={categoryGA}
                    scrollToBookingEngineEntryPoint={scrollToBookingEngineEntryPoint}
                  />
                );
              })}
            </Fragment>
          ) : (
            <Scrollable hasArrows={false} childrenWrapperClassNames="flex px-6">
              {suggestions.map((suggestion, index) => {
                return (
                  <AlternativeResortThumbnail
                    key={suggestion.resort.id}
                    suggestion={suggestion}
                    className={index < suggestions.length - 1 ? 'rtl:mr-4' : undefined}
                    onClick={selectResortHandler}
                    categoryGA={categoryGA}
                    scrollToBookingEngineEntryPoint={scrollToBookingEngineEntryPoint}
                  />
                );
              })}
            </Scrollable>
          )}
        </div>
      </div>
      <div className="md:border-t md:border-dotted md:mb-6" />
    </div>
  );
};
